<template>
  <div>
    <div v-if="loading">
      <LoadingSpinner />
    </div>
    <div class="card no-border p-2" v-else>
      <div
        v-if="
          ['bdr-commissions', 'bdr-objective', 'bdr-performance', 'client-task-verified'].includes(
            this.method
          )
        "
      >
        <button
          class="btn btn-outline-primary"
          :class="timechart == 'day' ? 'active' : ''"
          @click="changeChart('day')"
        >
          <small>
            {{ $t("lang.label.days") }}
          </small>
        </button>
        <button
          class="btn btn-outline-primary ml-2"
          :class="timechart == 'week' ? 'active' : ''"
          @click="changeChart('week')"
        >
          <small>
            {{ $t("lang.label.weeks") }}
          </small>
        </button>
        <button
          class="btn btn-outline-primary ml-2"
          :class="timechart == 'month' ? 'active' : ''"
          @click="changeChart('month')"
        >
          <small>
            {{ $t("lang.label.months") }}
          </small>
        </button>

        <h5
          class="text-primary"
          v-if="
            !['bdr-commissions', 'bdr-objective', 'bdr-performance', 'client-task-verified'].includes(
              this.method
            )
          "
        >
          {{
            $t("lang.opportunities.byday", { task: ratio, days: totalratio })
          }}
        </h5>
        <h5
          v-if="false"
          :class="
            multiaxis.datasets[0].data[multiaxis.datasets[0].data.length - 1] <
            ratio
              ? 'text-danger'
              : 'text-primary'
          "
        >
          {{ $t("lang.label.today") }}:
          {{
            multiaxis.datasets[0].data[multiaxis.datasets[0].data.length - 1]
          }}
          <img
            v-if="
              multiaxis.datasets[0].data[
                multiaxis.datasets[0].data.length - 1
              ] > ratio
            "
            src="@/assets/images/bravo.gif"
            width="40px"
          />
        </h5>
        <p
          v-if="
            multiaxis.datasets[0].data[multiaxis.datasets[0].data.length - 1] <
            ratio
          "
          class="text-danger"
        >
          {{ $t("lang.opportunities.badnews") }}
        </p>

        <line-chart
          :key="keylinkechart"
          :width="300"
          :height="100"
          :chart-data="multiaxis"
          :options="multiaxis.options"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { statusBadgeMixin, statusPointMixin } from "@/_mixins/";
import { mapState, mapActions } from "vuex";
import { router } from "@/_helpers";
import moment from "moment";
import Header from "@/components/Header.vue";
import LineChart from "@/components/Chart.vue";
import BubbleChart from "@/components/BubbleChart.vue";
import DoughnutChart from "@/components/DoughnutChart.vue";
import RadarChart from "@/components/RadarChart.vue";
import BarChart from "@/components/BarChart.vue";
import {
  businessContactService,
  opportunitiesService,
  usersService,
  campaignsService,
  categoriesService,
} from "@/_services";
import { monitorService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import CampaignStatistics from "@/components/Campaigns/CampaignStatistics.vue";
import MyCampaign from "@/components/Campaigns/MyCampaign.vue";
export default {
  data() {
    let self = this;
    return {
      bdrCommissionPercentage: 28,
      keylinkechart: 122,
      loading: true,
      ratio: 0,
      totalratio: 0,
      checkBilling: false,
      currentPage: 1,
      cantPerPage: 50,
      cantPerPageOptions: [5, 10, 20, 50, 100],
      selected: [],
      selectedSearch: [],
      selectedGoogle: [],
      searchFilter: "",
      day: "",
      date: "",
      timechart: "day",
      datePickerConfig: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        // minDate: moment().startOf("day")
        maxDate: moment().endOf("day"),
      },
      datePickerConfigEndDate: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        maxDate: moment().endOf("day"),
      },

      multiaxis: {
        labels: [],
        datasets: [
          {
            type: "bar",
            label: this.$t("lang.label.treated"),
            hidden: false,
            borderColor: "RGB(173,198,244,1)",
            backgroundColor: "RGBA(173,198,244,0.50)",
            pointBackgroundColor: "rgba(220,220,220,1)",
            data: [],
          },
          {
            type: "bar",
            label: this.$t("lang.label.tobetreated"),
            hidden: true,
            borderColor: "rgba(255,255,255,1)",
            backgroundColor: "RGBA(82,110,118,0.48)",
            pointBackgroundColor: "rgba(220,220,220,1)",
            data: [],
          },
        ],
        options: {
          responsive: true,
          title: {
            display: true,
            text: this.title,
          },
          scales: {
            xAxes: [
              {
                stacked: true,
                offset: true,
                // categoryPercentage: 0.5, // deprecated
                // barPercentage: 1, // deprecated
              },
            ],
            yAxes: [
              {
                stacked: true,
              },
            ],
          },

          plugins: {
            datalabels: {
              color: "blue",
              anchor: "end",
              align: "right",
              labels: {
                title: {
                  font: {
                    weight: "bold",
                  },
                },
              },
            },
          },
        },
      },

      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label || "";

            if (label) {
              label += ": ";
            }
            label +=
              parseFloat(
                tooltipItem.yLabel + self.bdrCommissionPercentage
              ).toFixed(2) + "%";
            return label;
          },
        },
      },

      BDRyAxes: [
        {
          stacked: true,
          id: "y1",
        },
        {
          stacked: true,
          id: "y2",
          position: "right",
          ticks: {
            beginAtZero: true,
            min: 0,
            precision: 2,
            callback: (value, index, values) => {
              return parseFloat(value).toFixed(2);
            },
          },
        },
      ],

      BDRObjectiveyAxes: [
        {
          stacked: true,
          id: "y1",
          ticks: {
            beginAtZero: false,
            min: -28,
            max: 100,
            precision: 2,
            callback: (value, index, values) => {
              return parseFloat(value + this.bdrCommissionPercentage).toFixed(
                2
              );
            },
          },
        },
      ],
      BDRCommissionsDatasets: [
        {
          type: "line",
          label: this.$t("lang.label.commissions"),
          hidden: false,
          borderColor: "RGBA(204,0,0,1)",
          backgroundColor: "RGBA(255, 255, 255,0)",
          pointBackgroundColor: "RGBA(204,0,0,1)",
          data: [],
          yAxisID: "y2",
        },
        {
          type: "bar",
          label: this.$t("lang.label.meetings"),
          hidden: false,
          borderColor: "rgba(255,255,255,1)",
          backgroundColor: "RGBA(54, 162, 235,0.48)",
          pointBackgroundColor: "rgba(220,220,220,1)",
          data: [],
          yAxisID: "y1",
        },
      ],
      BDRObjectiveDatasets: [
        {
          type: "bar",
          label: this.$t("lang.label.objective"),
          hidden: false,
          borderColor: "rgba(255,255,255,1)",
          backgroundColor: "RGBA(54, 162, 235,0.48)",
          pointBackgroundColor: "rgba(220,220,220,1)",
          data: [],
          yAxisID: "y1",
        },
      ],

      verifiedTasksByClientDatasets: [
        {
          type: "line",
          label: this.$t("lang.label.tasks"),
          hidden: false,
          borderColor: "RGB(173,198,244,1)",
          backgroundColor:"RGBA(51, 204, 204,0.28)",
          pointBackgroundColor: "rgba(220,220,220,1)",
          data: [],
          yAxisID: "y1",
        },   
      ],

      BDRPerformancesDatasets: [
        {
          type: "line",
          label: this.$t("lang.label.conversionrate"),
          hidden: false,
          borderColor: "RGBA(3, 252, 40,1)",
          backgroundColor: "RGBA(255, 255, 255,0)",
          pointBackgroundColor: "RGBA(3, 252, 40,1)",
          data: [],
          yAxisID: "y2",
        },
        {
          type: "bar",
          label: this.$t("lang.label.tasks"),
          hidden: false,
          borderColor: "RGB(173,198,244,1)",
          backgroundColor: "RGBA(252, 186, 3,0.48)",
          pointBackgroundColor: "rgba(220,220,220,1)",
          data: [],
          yAxisID: "y1",
        },
        {
          type: "bar",
          label: this.$t("lang.label.opportunities"),
          hidden: false,
          borderColor: "rgba(255,255,255,1)",
          backgroundColor: "RGBA(204,0,0,0.48)",
          pointBackgroundColor: "rgba(220,220,220,1)",
          data: [],
          yAxisID: "y1",
        },
        {
          type: "bar",
          label: this.$t("lang.refuse.absentlabel"),
          hidden: false,
          borderColor: "rgba(255,255,255,1)",
          backgroundColor: "RGBA(82,190,128,0.48)",
          pointBackgroundColor: "rgba(220,220,220,1)",
          data: [],
          yAxisID: "y1",
        },
        {
          type: "bar",
          label: this.$t("lang.label.meetings"),
          hidden: false,
          borderColor: "rgba(255,255,255,1)",
          backgroundColor: "RGBA(54, 162, 235,0.48)",
          pointBackgroundColor: "rgba(220,220,220,1)",
          data: [],
          yAxisID: "y1",
        },
      ],
      dataTimechart: { day: {} },
      dataColumns: {
        "bdr-commissions": [
          { name: "commission_amount", format: "float" },
          { name: "appt_bdr_qty", format: "int" },
        ],
        "bdr-objective": [
          { name: "objective_percentage", format: "basePercentage" },
        ],
        "bdr-performance": [
          { name: "appt_total", name2: "links_total", format: "percentage" },
          { name: "tasks_total", format: "int" },
          { name: "links_total", format: "int" },
          { name: "links_absent", format: "int" },
          { name: "appt_total", format: "int" },
        ],
        "client-task-verified": [
          { name: "verified_tasks", format: "int" },        ],
      },
    };
  },

  props: {
    method: String,
    range: Object,
    title: String,
    userId: {
      type: Number,
      default: 0,
    },
    planId: {
      type: String,
      default: '',
    },
  },

  components: {
    BubbleChart,
    RadarChart,
    BarChart,
    DoughnutChart,
    LineChart,
    LoadingSpinner,
  },

  mixins: [statusBadgeMixin, statusPointMixin],

  updated() {},

  computed: {
    user() {
      return this.$store.state.authentication.user;
    },

    ...mapState({
      currentUser: (state) => state.authentication.user,
      stats: (state) => state.campaigns.stats.data,
      model: (state) => state.campaigns.selected.data,
      loadingContacts2: (state) => state.contacts.loading,
      contacts2: (state) => state.contacts.all2.data,
      headerTab: (state) => state.header.tab,
    }),
  },

  created() {
    this.loadaxis();
  },
  watch: {
    timechart(timechart, before) {
      this.loading = true;
      let columns = this.dataColumns[this.method];
      if (
        (this.dataTimechart[timechart] == undefined && timechart == "month") ||
        (this.dataTimechart[timechart] == undefined && timechart == "week")
      ) {
        let result = this.dataTimechart["day"]["result"];

        this.dataTimechart[timechart] = {};
        this.dataTimechart[timechart]["labels"] = [];
        this.dataTimechart[timechart]["result"] = [];
        if (result !== undefined && result.length > 0) {
          result.forEach((row, index) => {
            let days = row.fdate.split("-");
            let day = new Date(days[0], days[1] - 1, days[2]);
            var refd = day.getFullYear() + "-" + days[1];

            if (timechart == "week") {
              var d = new Date(
                Date.UTC(day.getFullYear(), day.getMonth(), day.getDate())
              );
              var dayNum = d.getUTCDay() || 7;
              d.setUTCDate(d.getUTCDate() + 4 - dayNum);
              var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
              var week = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);

              if (days[1] + "-" + days[2] == "01-01") {
                week = 1;
              }
              if (days[1] + "-" + days[2] == "01-02") {
                week = 1;
              }

              refd = day.getFullYear() + " Week: " + week;
            }

            let pos = false;
            let yyy = this.dataTimechart[timechart]["result"].filter(
              (c, key) => {
                if (c.fdate == refd) {
                  pos = key;
                  return;
                }
              }
            );

            if (pos === false) {
              pos = 0;
              if (this.dataTimechart[timechart]["result"][0] !== undefined) {
                pos = this.dataTimechart[timechart]["result"].length;
              }
            }

            columns.forEach((column, index) => {
              let name = column.name;
              if (this.dataTimechart[timechart]["result"][pos] === undefined) {
                this.dataTimechart[timechart]["result"][pos] = {};
                this.dataTimechart[timechart]["result"][pos]["fdate"] = refd;
              }
              if (
                this.dataTimechart[timechart]["result"][pos][name] === undefined
              ) {
                this.dataTimechart[timechart]["result"][pos][name] = 0;
              }
              if (row[name] !== undefined) {
                if (column.format == "int") {
                  this.dataTimechart[timechart]["result"][pos][name] =
                    this.dataTimechart[timechart]["result"][pos][name] +
                    parseInt(row[name]);
                } else if (
                  ["float", "basePercentage"].includes(column.format)
                ) {
                  this.dataTimechart[timechart]["result"][pos][name] =
                    this.dataTimechart[timechart]["result"][pos][name] +
                    parseFloat(row[name]);
                }

                if (
                  this.dataTimechart[timechart]["result"][pos]["totalQty"] ===
                  undefined
                ) {
                  this.dataTimechart[timechart]["result"][pos]["totalQty"] = 0;
                }
                this.dataTimechart[timechart]["result"][pos]["totalQty"]++;
              }
            });
          });
        }
      }
      this.updateDataChart(timechart);
      this.loading = false;
    },
  },

  methods: {
    changeChart(type) {
      this.timechart = type;
    },
    getRandomRgb() {
      var num = Math.round(0xffffff * Math.random());
      var r = num >> 16;
      var g = (num >> 8) & 255;
      var b = num & 255;
      return r + ", " + g + ", " + b;
    },

    updateDataChart(timechart) {
      let columns = this.dataColumns[this.method];
      let result = this.dataTimechart[timechart]["result"];
      this.multiaxis.labels = [];
      columns.forEach((col, index) => {
        this.multiaxis.datasets[index].data = [];
      });
      let basePercentage = parseFloat(this.bdrCommissionPercentage);
      var barColors = [];

      result.forEach((row, key) => {
        this.multiaxis.labels[key] = row.fdate;
        columns.forEach((col, index) => {
          let value = row[col.name];
          if (col.format == "int") {
            value = parseInt(value);
          } else if (col.format == "float") {
            value = parseFloat(value).toFixed(2);
          } else if (col.format == "percentage") {
            value = (value * 100) / row[col.name2];
            value = parseFloat(value).toFixed(2);
          } else if (col.format == "basePercentage") {
            let totalQty = row["totalQty"] === undefined ? 1 : row["totalQty"];
            value = value / totalQty;
            if (value < basePercentage) {
              barColors.push("RGBA(204, 0, 0, 0.48)");
            } else {
              barColors.push("RGBA(3, 252, 40, 0.48)");
            }
            value = parseFloat(value - basePercentage).toFixed(2);
          }
          this.multiaxis.datasets[index].data[key] = value;
        });
      });
      if (barColors.length > 0) {
        this.multiaxis.datasets[0].backgroundColor = barColors;
      }
      this.keylinkechart++;
    },

    loadaxis() {
      this.loading = true;
      let userId = 1
      if(this.planId != '5'){
        userId =
        ["1", "9"].includes(this.currentUser.role_id) && this.userId > 0
          ? this.userId
          : this.currentUser.id;
      }
      
      monitorService
        .getMonitorUser(userId, this.method, this.range, null, this.planId)
        .then((result2) => {
          this.multiaxis.labels = [];
          if (this.method == "taggedgroup") {
            result2.forEach((row, key) => {
              if (Array.isArray(row)) {
                var r = row;
              } else {
                var r = Object.entries(row);
              }

              r.forEach((a, index) => {
                if (a[0] !== undefined) {
                  a = a[1];
                }
                if (this.multiaxis.labels.indexOf(a.date) < 0) {
                  this.multiaxis.labels.push(a.date);
                }
                if (this.multiaxis.datasets[index] === undefined) {
                  var rgbcolor = this.getRandomRgb();
                  this.multiaxis.datasets[index] = {
                    type: "bar",
                    label: a.name,
                    hidden: false,
                    borderColor: "RGB(" + rgbcolor + ",1)",
                    backgroundColor: "RGBA(" + rgbcolor + ",0.50)",
                    pointBackgroundColor: "rgba('+ rgbcolor+',1)",
                    data: [],
                  };
                }

                this.multiaxis.datasets[index].data.push(a.cant);
                this.multiaxis.datasets[index].label = a.name;
              });
            });
          } else if (this.method == "bdr-commissions") {
            this.multiaxis.datasets = this.BDRCommissionsDatasets;
            this.multiaxis.options.scales.yAxes = this.BDRyAxes;
            this.dataTimechart["day"]["result"] = result2;
            this.updateDataChart(this.timechart);
          } else if (this.method == "bdr-objective") {
            var barColors = [];
            this.multiaxis.datasets = this.BDRObjectiveDatasets;
            this.multiaxis.options.scales.yAxes = this.BDRObjectiveyAxes;
            this.multiaxis.options.tooltips = this.tooltips;
            // let basePercentage = parseFloat(this.bdrCommissionPercentage);
            // result2.forEach((row, key) => {
            //   this.multiaxis.labels[key] = row.fdate;
            //   let value = parseFloat(row.objective_percentage).toFixed(2);
            //   if (value < basePercentage) {
            //     barColors.push("RGBA(204, 0, 0, 0.48)");
            //   } else {
            //     barColors.push("RGBA(3, 252, 40, 0.48)");
            //   }
            //   value = parseFloat(value - basePercentage).toFixed(2);
            //   this.multiaxis.datasets[0].data[key] = value;
            // });
            // this.multiaxis.datasets[0].backgroundColor = barColors;
            this.dataTimechart["day"]["result"] = result2;
            this.updateDataChart(this.timechart);
          } else if (this.method == "bdr-performance") {
            this.multiaxis.datasets = this.BDRPerformancesDatasets;
            this.multiaxis.options.scales.xAxes[0].stacked = false;
            this.multiaxis.options.scales.yAxes = this.BDRyAxes;
            this.multiaxis.options.scales.yAxes[0].stacked = false;
            this.dataTimechart["day"]["result"] = result2;
            this.updateDataChart(this.timechart);
          } else if (this.method == "client-task-verified") {
            this.multiaxis.datasets = this.verifiedTasksByClientDatasets;
            this.multiaxis.options.scales.xAxes[0].stacked = false;
            this.multiaxis.options.scales.yAxes = this.BDRyAxes;
            this.multiaxis.options.scales.yAxes[0].stacked = false;
            this.dataTimechart["day"]["result"] = result2;
            this.updateDataChart(this.timechart);
          } else {
            result2.forEach((row, key) => {
              this.multiaxis.labels[key] = row.hour;
              this.multiaxis.datasets[0].data[key] = row.done;
              this.multiaxis.datasets[1].data[key] = row.pending;
              if (row.done > 0) {
                this.totalratio++;
              }
              this.ratio = Number(this.ratio) + Number(row.done);
            });
            this.ratio = Math.round(this.ratio / this.totalratio);
          }
        })
        .finally(() => {
          this.keylinkechart++;
          this.loading = false;
        });
    },
  },
};
</script>
<style>
.status-colors.positive {
  color: #61de4d;
}
.status-colors.paused {
  color: #babac2;
}
.status-colors.stopped {
  color: #ff6584;
}
.eff-blur {
  z-index: 20;
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;

  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  filter: blur(3px);
  -webkit-filter: blur(3px);
  -moz-filter: blur(3px);
  -o-filter: blur(3px);
  -ms-filter: blur(3px);
}
.eff-blur + div.effect-blur .table-responsive {
  filter: blur(3px);
  -webkit-filter: blur(3px);
  -moz-filter: blur(3px);
  -o-filter: blur(3px);
  -ms-filter: blur(3px);
}

.btn-outline-primary.active {
  color: #fff !important;
}
</style>
